import * as z from 'zod';

import { schema } from '.';
import { validateDuplicateCPFs } from '../../../../utils/validateUniqueCpf';

export const consignadoSchema = z
  .object({
    payment: z.optional(
      z.object({
        Type: z.optional(z.string()),
      }),
    ),
    user: schema,
  })
  .superRefine((data, ctx) => {
    const entries: { cpf?: string; path: (string | number)[] }[] = [];

    const user = data.user || {};

    if (user.documents?.cpf) {
      entries.push({
        cpf: user.documents.cpf,
        path: ['user', 'documents', 'cpf'],
      });
    }

    (user.dependents || []).forEach((dep, i) => {
      entries.push({
        cpf: dep.cpf,
        path: ['user', 'dependents', i, 'cpf'],
      });
    });

    validateDuplicateCPFs(entries, ctx);
  });

export type ConsignadoSchema = z.infer<typeof consignadoSchema>;
